import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import AssetThumbnail from "./AssetThumbnail";
import LuciPropTypes from "../propTypes/";
import Settings from "../settings";
import localize from "../util/localizeUtils";
import LoadingIndicator from "./LoadingIndicator";
import ReloadButton from "./ReloadButton";

class AssetList extends React.Component {
  renderEmpty = () => {
    const AssetListContainer = styled.div`
      height: 100%;
      min-height: ${this.props.minHeight
        ? `${this.props.minHeight}px`
        : "initial"};
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;
    `;
    let overlay = "";
    if (!this.props.loading && this.props.reload && this.props.error) {
      overlay = <ReloadButton onClick={this.props.reload} />;
    }
    return (
      <AssetListContainer>
        {overlay}
        {localize("emptyResultsText")}
      </AssetListContainer>
    );
  };

  render() {
    const {
      assetList,
      paddingLeft,
      paddingRight,
      loading,
      showFilePath,
      onDragStart,
      onDragEnd
    } = this.props;

    const AssetListContainer = styled.div`
      top: 4rem;
      bottom: ${this.props.footerHeight};
      overflow-x: hidden;
      overflow-y: auto;
      background-color: inherit;
      width: 100%;
      height: 100%;
      padding-left: ${props => (props.paddingLeft ? props.paddingLeft : "0")};
      flex-grow: 1;
      display: flex;
      flex-flow: row wrap;
      align-content: flex-start;
    `;
    if ((!assetList || assetList.length === 0) && !loading) {
      return this.renderEmpty();
    }
    return (
      <AssetListContainer paddingRight={paddingRight} paddingLeft={paddingLeft}>
        <LoadingIndicator visible={loading} />
        {assetList.map(asset => {
          const isMosObject = asset.mosObjectId !== undefined;
          const title = isMosObject ? asset.abstract : asset.title;
          return (
            <AssetThumbnail
              showFilePath={showFilePath}
              assetUrl={asset.assetUrl}
              categories={asset.categories}
              key={asset.id}
              filePath={asset.filePath}
              frameRate={asset.frameRate}
              isFavorite={asset.isFavorite}
              id={asset.id}
              author={asset.author}
              description={asset.description}
              fileName={asset.fileName}
              fileType={asset.fileType}
              imageSize={asset.imageSize}
              keywords={asset.keywords}
              lastModifiedDateTime={asset.lastModifiedDateTime}
              mediaFields={asset.mediaReplaceableData}
              proxyUrl={asset.proxyUrl}
              subject={asset.subject}
              templateTitle={asset.templateTitle}
              textFields={asset.textReplaceableData}
              title={title}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
              provider={asset.provider}
              thumbnailUrl={
                Settings.useHiResThumbnails || !asset.smallThumbnailUrl
                  ? asset.thumbnailUrl
                  : asset.smallThumbnailUrl
              }
              toggleFavorite={this.props.toggleFavorite}
              onClick={this.props.onClick}
              onDoubleClick={this.props.onDoubleClick}
            />
          );
        })}
      </AssetListContainer>
    );
  }
}

AssetList.defaultProps = {
  selectedAssetId: null,
  toggleFavorite: null,
  onClick: () => {},
  onDoubleClick: () => {},
  height: null,
  minHeight: null,
  assetList: [],
  paddingLeft: "0",
  paddingRight: "0",
  loading: false,
  reload: () => {},
  error: false,
  showFilePath: false,
  onDragStart: null,
  onDragEnd: null
};

AssetList.propTypes = {
  toggleFavorite: PropTypes.func,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  assetList: LuciPropTypes.AssetList,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  loading: PropTypes.bool,
  reload: PropTypes.func,
  error: PropTypes.bool,
  showFilePath: PropTypes.bool,
  footerHeight: PropTypes.string.isRequired,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func
};

const mapStateToProps = state => ({
  footerHeight: state.app.footerHeight
});

export default connect(mapStateToProps)(AssetList);



// WEBPACK FOOTER //
// ./app/components/AssetList.js